import { c as _c } from "react/compiler-runtime";
export interface BlockquoteProps {
  text: string;
  caption?: string;
}
export const Blockquote = t0 => {
  "use memo";

  const $ = _c(3);
  const {
    text,
    caption
  } = t0;
  let t1;
  if ($[0] !== caption || $[1] !== text) {
    t1 = caption ? <figure className="my-6 border-l-4" data-testid="blockquote"><blockquote className="max-w-(--breakpoint-lg) py-2 pl-4 font-serif text-xl italic lg:text-2xl lg:leading-9">{text}</blockquote><figcaption className="py-1 pl-4">{caption}</figcaption></figure> : <blockquote className="my-6 max-w-(--breakpoint-lg) border-l-4 py-2 pl-4 font-serif text-xl italic lg:text-2xl lg:leading-9">{text}</blockquote>;
    $[0] = caption;
    $[1] = text;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export type BlockquoteComponent = typeof Blockquote;